
import fundamentalSheetConstants from '@/constants/fundamental.constants';
import FormatterService from "@/service/FormatterService";
import FundChart from './FundChart.vue';

export default {
    name: "BalanceSheet",

    components: {
        FundChart, 
    },

    props: {
        tabKey: {
            type: Number,
            default: 0,
        },
        headers: {
            type: Array,
            default: () => []
        },
        rawData: {
            type: Array,
            default: () => []
        },
        isShowedFullYears: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: true
        },
        sections: {
            type: Array,
            default: () => []
        },
        formatMapping: {
            type: Object,
            default: null
        },
        selectedTimeFrame: {
            type: Number,
            default: null,
        },
        isTableView: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        numberOfColumns() {
            if (this.selectedTimeFrame == this.fundamentalTimeFrames.max) {
                return this.rawData.length
            }

            if (this.tabKey !== this.tabConstants.earnings) {
                return this.selectedTimeFrame
            }

            //earnings tabs will display by quarters, so it need to be handled specially
            let numberOfColumns = 0
            const years = new Set()

            for (const data of this.rawData) {
                years.add(data.date?.split('-')[0])
                if (years.size > this.selectedTimeFrame) {
                    break;
                }
                numberOfColumns++
            }

            return numberOfColumns
        },
        displayedDataMapping() {
            const result = {}
            if (!this.rawData[0]) {
                return result;
            }
            const keys = Object.keys(this.rawData[0]);
            
            keys.forEach(metric => {
                const formatInfo = this.formatMapping[metric];

                if (formatInfo) {
                    const { format } = formatInfo;

                    const data = this.rawData.map((curr) => {
                        const value = format ?
                            this.format.formatFundamentalData(curr[metric], format)
                            : curr[metric];
    
                        return value;
                    });

                    result[metric] = this.selectedTimeFrame == this.fundamentalTimeFrames.max ?  data : data.slice(0, this.numberOfColumns)
                }
            });
            return result
        },
        displayedHeaders() {
            if (this.tabKey !== this.tabConstants.earnings) {
                return this.headers
            }

            const headers = []
            headers.unshift({ text: this.$t('component.share.shareFundamentals.header.description'), value: 'metric' })

            for (let i = 0; i < this.numberOfColumns; i++) {
                headers.push({ text: this.rawData[i].date.split('-')[0], value: ''})
            }
            return headers
        }
    },

    watch: {
        isLoading(state) {
            if (!state) {
                this.isInitializing = false;
                this.checkTableOverflow()
            }
        },
        selectedTimeFrame() {
            this.checkTableOverflow()
        },
    },

    data() {
        return {
            format: new FormatterService(),
            isInitializing: true,
            fullDataMapping: {},
            firstYearsDataMapping: {},
            overflow: false,
        }
    },

    created() {
        this.fundamentalTimeFrames = fundamentalSheetConstants.fundamentalTimeFrames
        this.tabConstants = fundamentalSheetConstants.tabConstants
    },

    methods: {
        async checkTableOverflow() {
            await this.$nextTick()
            if (!this.$refs.tableHeader?.[0]) {
                this.overflow = false
                return
            }
            this.overflow = this.$refs.tableHeader[0].clientWidth > this.$refs.table[0].$el.clientWidth;
        }
    },
}
